<template>
    <div class="ct-input-element">
        <div class="ct-title ct-v-align">
            <label v-if="!isRequired" :for="inputFieldId">{{ label }}</label>
            <label v-if="isRequired" :for="inputFieldId">{{ label }}*</label>
            <i
                v-show="hasHint"
                class="material-icons"
                data-toggle="tooltip"
                data-placement="bottom"
                :title="$t(getHint)"
                :data-original-title="$t(getHint)"
                >help_outline</i
            >
        </div>
        <div class="ct-content" :class="{ 'has-error': hasError }">
            <select :name="inputFieldId" :id="inputFieldId" v-model="selectModel" class="form-control">
                <option v-for="option in selectOptions" :value="option.value">{{ option.label }}</option>
            </select>
        </div>
        <div :class="{ 'has-error': hasError }">
            <span v-show="hasError" class="help-block">{{ getError }}</span>
        </div>
    </div>
</template>
<script>
import _ from 'underscore';

export default {
    props: ['config', 'inputModel', 'error', 'options', 'preSelect'],
    data() {
        return {
            selected: ''
        };
    },
    computed: {
        selectOptions() {
            let options = [];
            for (let i = 0; i < this.options.length; i++) {
                options.push({ label: this.$t(this.config.prefix + '.' + this.options[i]), value: this.options[i] });
            }

            if (!this.config.noSort) {
                options = _.sortBy(options, 'label');

                options = _.sortBy(
                    this.options.map(option => {
                        if (option.noTranslation) {
                            return option;
                        }
                        return { label: this.$t(this.config.prefix + '.' + option), value: option };
                    }),
                    'label'
                );
            } else {
                options = this.options.map(option => {
                    if (option.noTranslation) {
                        return option;
                    }
                    return { label: this.$t(this.config.prefix + '.' + option), value: option };
                });
            }

            if (this.config.preferredOptions && this.config.preferredOptions.length > 0) {
                options.unshift({ label: '---', value: '---' });
                for (let i = this.config.preferredOptions.length - 1; i >= 0; i--) {
                    options.unshift({
                        label: this.$t(this.config.prefix + '.' + this.config.preferredOptions[i]),
                        value: this.config.preferredOptions[i]
                    });
                }
            }

            return options;
        },
        selectModel: {
            get() {
                if (this.selected) {
                    return this.selected;
                } else if (this.preSelect) {
                    if (this.preSelect !== this.inputModel) {
                        this.$emit('update:inputModel', this.preSelect);
                    }
                    return this.preSelect;
                }

                return undefined;
            },
            set(newValue) {
                this.selected = newValue;
                if (newValue) {
                    this.$emit('update:inputModel', newValue);
                    if (this.error) {
                        this.$emit('resetValidation');
                    }
                }
            }
        },
        inputFieldId() {
            if (this.config && this.config.id) {
                return this.config.id;
            }

            return '';
        },
        label() {
            if (this.config && this.config.translationKey) {
                return this.$i18n.t(this.config.translationKey);
            }

            return '';
        },
        isRequired() {
            return this.config && this.config.required;
        },
        getHint() {
            return this.hasHint ? this.config.hint : '';
        },
        hasHint() {
            return this.config && this.config.hint;
        },
        hasError: function() {
            return this.error;
        },
        getError() {
            return this.hasError ? this.error : '';
        }
    }
};
</script>
